import React from 'react';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { About } from '../components/About';
import { Team } from '../components/Team';
import { Testimonials } from '../components/Testimonials';
import { BookingCTA } from '../components/BookingCTA';
export function Home() {
  return <>
      <Hero data-id="element-269" />
      <Services data-id="element-270" />
      <About data-id="element-271" />
      <Team data-id="element-272" />
      <Testimonials data-id="element-273" />
      <BookingCTA data-id="element-274" />
    </>;
}